













import PopupTemplate from '@/views/templates/PopupTemplate.vue'

export default
  components: {
    PopupTemplate
  }

  props: {
    quizData:
      type: Object
      default: {}
  }

  data: () ->
    mode: 0

  methods: {
    closePopup: () ->
      @$emit('closePopup')
    answer: (code) ->
      if code == @quizData.answer
        @mode = 2
        @$emit('success')
      else
        @mode = 1
        @$emit('miss')

  }
